<template>
    <div class="float-left mr-1">
            <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Alerta"
                @click.stop="abrirModalAtualizar()"
            ></i>
        </span>
        <b-modal id="modalAtualizar" v-model="mostrarModal">
            <div slot="modal-title">
                Alertas -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col>
                    <b-form-group>
                        <label>Vigência do Contrato: 
                            <strong> 
                                {{ $moment(dataInicioVigencia).format('DD/MM/YYYY') }} 
                                a 
                                {{ $moment(dataFimVigencia).format('DD/MM/YYYY') }}
                            </strong>
                        </label>
                    </b-form-group> 
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group
                        :state="!camposInvalidos.dataAlerta"
                        invalid-feedback="Data do Alerta é obrigatória"
                    >
                        <label class="required">Data do Alerta</label>
                        <date-picker
                            v-model="dataAlerta"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group> 
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="!camposInvalidos.motivo"
                        invalid-feedback="Motivo é obrigatório"
                    >
                        <label class="required">Motivo</label>
                        <b-form-textarea
                            v-model="motivo"
                            :rows="2"
                            :maxlength="50"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmarAtualizar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>

        </b-modal>
    </div>
</template>

<script>
import AlertasServicos from './AlertasServicos';


export default {
    components: {

    },
    props: {
        idContrato: {
            type: String
        },
        alerta: {
            type: Object
        },
        dataInicioVigencia: {
            type: String
        },
        dataFimVigencia: {
            type: String
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAR',
            dataAlerta: '',
            motivo: '',
            erros: [],
            camposInvalidos: {
                dataAlerta: false,
                motivo: false,
            },
        }
    },
    methods: {
        abrirModalAtualizar() {
            this.mostrarModal = true
            this.dataAlerta = this.$moment(
                    this.alerta.dataAlerta
                ).format('DD/MM/YYYY')
            this.motivo = this.alerta.motivo
        },

        fecharModalAtualizar() {
            this.mostrarModal = false
            this.erros = []
        },

        confirmarAtualizarModal() {
            this.$swal({
                title: 'Confirmação',
                html: `Confirma a atualização do alerta para a data ${this.dataAlerta}?`,
                icon: 'warning', 
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('atualizarAlerta')
                    this.salvarAtualizacaoAlerta()
                }
            })
        },

        salvarAtualizacaoAlerta() {
            let alertasDto = {
                dataAlerta: this.dataAlerta
                            ? this.$moment(this.dataAlerta, 'DD/MM/YYYY').toISOString()
                            : '',
                motivo: this.motivo,
                idContrato: this.idContrato,
                alertaId: this.alerta.alertaId,
            }
            this.$store.dispatch('addRequest')
            AlertasServicos.atualizarAlerta(alertasDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.registroAtualizadoComSucesso(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
           
        },

        obterAlertasPorContrato() {
            this.$emit('obterAlertasVigencia')
        },

        registroAtualizadoComSucesso() {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAlertasAtualizados')
            this.fecharModalAtualizar()
        },

        abrirModalInserirAlerta() {
            this.mostrarModalInserirAlerta = true;
            this.resetarErros();
        },

        fecharModalInserirAlerta() {
            this.mostrarModalInserirAlerta = false;
            this.resetarErros();
        },

        resetarErros() {
            this.erros = [];
            this.camposInvalidos = {
                dataAlerta: false,
                motivo: false,
            };
        },

        validarCampos() {
            let valido = true;

            if (!this.dataAlerta) {
                this.camposInvalidos.dataAlerta = true;
                valido = false;
            } else {
                this.camposInvalidos.dataAlerta = false;
            }

            if (!this.motivo || this.motivo.trim() === "") {
                this.camposInvalidos.motivo = true;
                valido = false;
            } else {
                this.camposInvalidos.motivo = false;
            }

            return valido;
        },

        confirmarAtualizar() {
            if (this.validarCampos()) {
                this.confirmarAtualizarModal();
            } else {
                this.erros = ["Preencha todos os campos obrigatórios."];
            }
        },
    }
}
</script>